import { Card, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import '@features/Incentive/incentive.css';
import { DashboardSelector } from '../store/DashboardSelector';
import { useEffect, useMemo } from 'react';
import { GetKFSDashboard } from '../business/DashboardBusiness';
export const KFSUserDashboard = () => {
  const dispatch = useDispatch();
  const dashboardState = useSelector(DashboardSelector);
  const data = useMemo(() => dashboardState.KFSUserDashboardList || [], [dashboardState.KFSUserDashboardList]);

  const columns = [
    {
      title: 'Username',
      dataIndex: 'Username',
      key: 'Username',
      sorter: (a, b) => a.Username.localeCompare(b.Username),
    },
    {
      title: 'Name',
      dataIndex: 'CompleteName',
      key: 'CompleteName',
    },
    {
      title: 'Role',
      dataIndex: 'RoleName',
      key: 'RoleName',
      sorter: (a, b) => a.RoleName.localeCompare(b.RoleName),
    },
    {
      title: 'Work location',
      dataIndex: 'States',
      key: 'States',
      sorter: (a, b) => a.States.localeCompare(b.States),
    },
    {
      title: 'Status',
      dataIndex: 'AccountStatus',
      key: 'AccountStatus',
      sorter: (a, b) => a.AccountStatus.localeCompare(b.AccountStatus),
    },
    {
      title: 'Created date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
    },
  ];
  useEffect(() => {
    const fetchData1 = async () => {
      await dispatch(GetKFSDashboard());
    };

    fetchData1();
  }, [dispatch]);

  return (
    <div className="App">
      <Card>
        <Table dataSource={data} columns={columns} pagination={{ pageSize: 100 }} />
      </Card>
    </div>
  );
};
